import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";

interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
}

interface State {

}
export class CurrencyComponent extends React.Component<Props, State> {
   
  
    constructor(props: Props) {
        super(props);

    
        let field = this.props.field;
      FormValidationUtils.runJavascript(field);
    }

  onTextEditChange = (e) => {
    let field = this.props.field;

    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;
    field.Value = val;

    
    FormValidationUtils.validateCurrency(field)

    FormValidationUtils.runJavascript(field);
    
    this.props.callbackElement(field.parent.parent.parent);
  }


  render() {
    let field = this.props.field;
    if(!field.Visible) return null;

    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];

    if (editable) {
      controlArray.push(
        <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>
          <div key={'fdLbl_div_' + field.Id} >
            {labelControlArray}
          </div>
          <LiveValidationErrMsg
            field={this.props.field}
            isEng={this.props.isEng}
            key={"LiveValidationErrMsg_" + field.LoadBindName} />
         
          <input className={this.props.field.Valid || !this.props.field.Touched?'ontario-input':'ontario-input ontario-input__error'} 
          id={field.LoadBindName}  key={'fdIpt_currency_' + field.Id}
            min={field.MinValue} max={field.MaxValue} type="number" step="0.01"
            required={requiredField} value={field.Value} readOnly={field.ReadOnly} onChange={this.onTextEditChange} />
        </div>);
    } else {
      controlArray.push(
        <div className='pdf-two-column' >
          <div>{field.ENUTitle}</div>
          <div className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} > {field.Value}</div>
        </div>
      );
    }

    return controlArray;
  }

}